// src/components/BidCard.jsx
import React, { useState } from 'react';
import './BidCard.css';
import foodImage from '../image/food-img.png'; // replace with your actual image path
import { is, sl, tr } from 'date-fns/locale';
import { API_BASE_URL } from '../../utils';
import { IoLocationOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { MdRestaurant } from "react-icons/md";
import { BiSolidDrink } from "react-icons/bi";

const BidCard = ({ data, istableleads }) => {


    const url = `${API_BASE_URL}/master/assets/uploads/`;

    const format = (str) => (str ? str?.trim().replace(/\s+/g, "-").toLowerCase() : "");
    const packageNameParams = format(data?.title);

    console.log("table data", data)



    return (
        <>
            <Link
                to={
                    istableleads
                        ? `/${data?.club_slug}/${data?.id}`
                        : `/bid-detail/${data?.club_slug}/${format(data?.title)}/${data?.id}`
                }
            >

                <div className="bid-card">
                    <img src={url + data?.clubLogo} alt="Food" className="bid-card-image" />
                    <div className="bid-card-info">
                        <div className='bid-card-text-sec'>
                            <h3 className="bid-title">{data?.clubName}</h3>
                            <p className="bid-subtitle">
                                {data?.title?.length > 20
                                    ? `${data.title.slice(0, 20)}...`
                                    : data?.title}
                            </p>

                            {istableleads && (
                                <p className='bid-table-city-area'>{data?.area || "Sector 38"}{" "}{data?.city || "Noida"}</p>
                              
                            )}
                            <div className="view-link" >View Details</div>
                        </div>
                        <div className="bid-amount">

                            {istableleads ? (
                                <>
                                    <span className='tablediscount-title'>Discount Offer</span>
                                    <div className='tablediscount-box-section'>
                                        <span className='tablediscount-box-wrap'>
                                            <span className='tablediscount-overlay'>
                                                <MdRestaurant />{" "} {data?.food_discount}%{" "}off
                                            </span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="28" viewBox="0 0 89 28" fill="none">
                                                <path d="M9.74698 3.40078C11.0117 1.29106 13.291 0 15.7508 0H82C85.866 0 89 3.13401 89 7V21C89 24.866 85.866 28 82 28H7.35792C1.91804 28 -1.44293 22.0665 1.35412 17.4008L9.74698 3.40078Z" fill="#006D0D" />
                                            </svg>
                                        </span>

                                        <span className='tablediscount-box-wrap'>
                                            <span className='tablediscount-overlay'>
                                                <BiSolidDrink />{" "} {data?.slab_details?.length
                                                    ? data.slab_details[data?.slab_details.length - 1]?.discount
                                                    : "N/A"}%{" "}off
                                            </span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="28"  viewBox="0 0 89 28" fill="none">
                                                <path d="M9.74698 3.40078C11.0117 1.29106 13.291 0 15.7508 0H82C85.866 0 89 3.13401 89 7V21C89 24.866 85.866 28 82 28H7.35792C1.91804 28 -1.44293 22.0665 1.35412 17.4008L9.74698 3.40078Z" fill="#006D0D" />
                                            </svg>
                                        </span>


                                    </div>
                                </>
                               
                            ) : (
                                <>
                                    <span>Bid Amount</span>
                                    <strong className="bid-amount-value">Rs {data?.price}/-</strong>
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </Link >
        </>
    );
};

export default BidCard;
